// extracted by mini-css-extract-plugin
module.exports = {"header":"CustomH2_header__1D4Gz"};